angular.module('qkr').factory('contactDetailsService', ($http, $q, appConfig) => ({
        listCityStateForMerchant() {
            const deferred = $q.defer();

            $http.get(appConfig.apiUrl + 'contactDetails/listCityState', {withCredentials: true}).then(
                (response) => {
                    deferred.resolve(response.data);
                },
                (reason) => {
                    deferred.reject(reason);
                }
            );

            return deferred.promise;
        }
    }));



// WEBPACK FOOTER //
// ./src/services/contact.details.services.js